var _effectorFileName = "/builds/gmini/front-ui-kit/src/MacosExplorer/ExplorerBody/ExplorerPanel.tsx";

/* eslint-disable react/forbid-component-props */
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import clsx from 'clsx';
import { useDrop } from 'react-dnd';
import { useExplorerProps } from '../propsCtx';
import { DefaultPanelRender } from './DefaultPanelRender';
import { ExplorerItem } from './ExplorerItem';
import { jsx as _jsx } from "react/jsx-runtime";
export function ExplorerPanel(props) {
  const {
    onPanelContextMenu,
    item,
    panelWidth,
    activeItems
  } = props;
  const classes = useStyles({
    panelWidth
  });
  const {
    PanelRender: FromPropsPanelRender
  } = useExplorerProps();
  const scrollRef = React.useRef(null);
  const PanelRender = FromPropsPanelRender ? FromPropsPanelRender : DefaultPanelRender;

  const getScrollElem = () => scrollRef.current;

  const onContextMenu = React.useCallback(e => {
    if (onPanelContextMenu) {
      onPanelContextMenu(e, item.payload);
    }
  }, [onPanelContextMenu, item.payload]); //TODO выпилить или заимплементить dnd

  const [{
    isOver,
    isCanDrop
  }, dropRef] = useDrop({
    accept: props.dndType,
    collect: monitor => ({
      isOver: monitor.isOver({
        shallow: true
      }),
      isCanDrop: monitor.canDrop()
    }),
    canDrop: ({
      node: nodeForDrop
    }) => props.canDrop && props.canDrop(item.payload, nodeForDrop) || false,
    drop: ({
      node: droppedNode
    }) => {
      if (isOver && props.onMove) {
        props.onMove(item.payload, droppedNode);
      }
    }
  });
  return /*#__PURE__*/_jsx("div", {
    ref: dropRef,
    className: clsx(classes.root, {
      [classes.isOver]: isOver && isCanDrop
    }),
    onContextMenu: onContextMenu,
    "data-test-column-id": activeItems.indexOf(item) + 1 || 0,
    children: /*#__PURE__*/_jsx(Scrollbars, {
      ref: scrollRef,
      className: classes.root,
      children: /*#__PURE__*/_jsx("div", {
        className: classes.paddingWrap,
        children: /*#__PURE__*/_jsx(PanelRender, { ...props,
          ExplorerItem: ExplorerItem,
          getScrollElem: getScrollElem
        })
      })
    })
  });
}
ExplorerPanel.displayName = 'ExplorerPanel';
export const useStyles = makeStyles({
  root: {
    minWidth: props => `${props.panelWidth}px`,
    width: props => `${props.panelWidth}px`,
    maxWidth: props => `${props.panelWidth}px`,
    height: '100%',
    borderRight: '1px solid #E2E4E9',
    '&:last-child': {
      borderRight: 'none'
    }
  },
  isOver: {
    background: '#F4F4FA'
  },
  paddingWrap: {
    paddingTop: '10px',
    paddingLeft: '10px',
    paddingBottom: '70px'
  }
});